export default __webpack_public_path__ + "static/media/icon_graphs.e4447e09.svg";